import { DCFormatter, HistoryFormatter, ReviewsFormatter } from './formatters';
import './styles.css';
import {
  CareProgressRowData,
  PMMDocument,
  PMMScriptWritten,
  type PMMNameTypes,
} from './types';

const careProgressColumns: any[] = [
  {
    text: (
      <div className="d-flex flex-column gap-2 care-progress-header-inner">
        <div className="care-progress-placeholder">CARE PROGRESS</div>
        <div>History</div>
      </div>
    ),
    sort: false,
    classes: 'col4 care-progress-col care-progress-first',
    headerClasses: 'col4 care-progress-col care-progress-first',
    formatter: (cell: any, row: any) => {
      const data = mapToCareProgressRowData(row, PMMDocument.HISTORY);
      return <HistoryFormatter id={`history-${row.id}`} rowData={data} />;
    },
  },
  {
    text: (
      <div className="d-flex flex-column gap-2 care-progress-header-inner">
        <div className="care-progress-placeholder" />
        <div>Reviews</div>
      </div>
    ),
    sort: false,
    classes: 'col4 care-progress-col',
    headerClasses: 'col4 care-progress-col',
    formatter: (cell: any, row: any) => {
      const data = mapToCareProgressRowData(row, PMMDocument.REVIEW);
      return <ReviewsFormatter id={`reviews-${row.id}`} rowData={data} />;
    },
  },
  {
    text: (
      <div className="d-flex flex-column gap-2 care-progress-header-inner">
        <div className="care-progress-placeholder" />
        <div>D/C</div>
      </div>
    ),
    sort: false,
    classes: 'col4 care-progress-col',
    headerClasses: 'col4 care-progress-col',
    formatter: (cell: any, row: any) => {
      const scriptWrittenData = mapToCareProgressRowData(
        row,
        PMMScriptWritten.SCRIPT_WRITTEN,
      );
      const dischargeData = mapToCareProgressRowData(row, PMMDocument.DC);
      return (
        <DCFormatter
          id={`${row.id}`}
          scriptWrittenData={scriptWrittenData}
          dischargeData={dischargeData}
        />
      );
    },
  },
];

const mapToCareProgressRowData = (
  row: any,
  type: PMMNameTypes,
): CareProgressRowData[] => {
  const pmmEvents = (row.pmmEvents as any[]) || [];
  const events = pmmEvents.filter((event) => event.name === type);
  const results = events.map((event) => ({
    id: event.id,
    event_date: event.event_date,
    patient_id: event.patient_id,
    name: event.name,
    tenancy_id: event.tenancy_id,
    detail: {
      status: event.detail.status,
    },
    episode_id: event.episode_id,
  }));
  return results;
};

export default careProgressColumns;
